document.addEventListener('DOMContentLoaded', () => {
  const HeaderIds = {
    CloseButton: 'close-button',
    MenuButton: 'menu-button',
  };
  const ClassNames = {
    Subscribe: 'subscribe',
  };

  const closeBtn = document.getElementById(HeaderIds.CloseButton);
  const menuBtn = document.getElementById(HeaderIds.MenuButton);
  const nav = document.getElementsByTagName('nav')[0];
  const subscribe = document.getElementsByClassName(ClassNames.Subscribe)[0];
  const emailLabel = subscribe.getElementsByTagName('p')[0];
  const emailInput = subscribe.getElementsByTagName('input')[0];

  closeBtn.addEventListener('click', () => {
    nav.classList.remove('show');
    nav.classList.add('hide');
    document.body.style.overflow = 'unset';
  });

  menuBtn.addEventListener('click', () => {
    nav.classList.remove('hide');
    nav.classList.add('show');
    document.body.style.overflow = 'hidden';
  });

  emailInput.addEventListener('blur', () => {
    if (!emailInput.value) {
      emailLabel.classList.remove('hide');
      emailLabel.classList.add('show');
    }
  });

  emailInput.addEventListener('focus', () => {
    emailLabel.classList.remove('show');
    emailLabel.classList.add('hide');
  });

  const successToast = document.querySelector('.newsletter-form__message--success');

  if (successToast) {
    const headerEl = document.querySelector('header');
    const headerHeight = headerEl ? headerEl.getBoundingClientRect().height : 96;
    successToast.style.top = headerHeight + 12 + 'px';

    requestAnimationFrame(() => {
      successToast.classList.add('is-visible');
    });

    setTimeout(() => {
      successToast.classList.remove('is-visible');
      setTimeout(() => {
        successToast.style.display = 'none';
      }, 350);
    }, 4000);
  }
});
